const PLUGIN_NAME = 'ecommerce-context';
const LOCAL_CART_KEY = 'blaze_cart_id';
const LOCAL_CURRENCY_KEY = 'blaze_cart_currency_code';
const LOCAL_CART_UPDATED_KEY = 'blaze_cart_updated';
const CONTEXT_KEYS = {
  currencyKey: 'currency',
  variantKey: 'variant',
  cartIdKey: 'cartId',
  cartDataKey: 'cartData'
};
const DEFAULT_CURRENCY = 'gbp';

export {
  PLUGIN_NAME,
  LOCAL_CART_KEY,
  LOCAL_CURRENCY_KEY,
  LOCAL_CART_UPDATED_KEY,
  CONTEXT_KEYS,
  DEFAULT_CURRENCY
};
